export default __webpack_public_path__ + "static/media/home-business-services-img01.7344bce5.jpg";